import "./App.css";
import { Routes, Route, Link, NavLink } from "react-router-dom";
import Home from "./Component/Home.js";
import Link01 from "./Component/Link01";
import Link02 from "./Component/Link02";
import Link03 from "./Component/Link03";
import Link04 from "./Component/Link04";
import Tab from "./Component/Tab";

function App() {
  return (
    <div className="nav">
      <ul>
        <li>
          <img src="https://blog.kakaocdn.net/dn/cCyVr7/btqyZXX4PAV/duwsnRMn23EKx2e2uUumJ1/img.gif"></img>
        </li>
        <li>
          {" "}
          <Link to="/">심플 홈페이지</Link>
        </li>
        <li>
          <Link to="/link01">사이트 소개</Link>
        </li>
        <li>
          <Link to="/link02">정보마당</Link>
        </li>
        <li>
          <Link to="/link03">고객지원</Link>
        </li>
        <li>
          <Link to="/link04">알림마당</Link>
        </li>
      </ul>
      <hr></hr>
      <Tab />
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/link01" element={<Link01 />}></Route>
        <Route path="/link02" element={<Link02 />}></Route>
        <Route path="/link03" element={<Link03 />}></Route>
        <Route path="/link04" element={<Link04 />}></Route>
      </Routes>
      <div className="zaryo">
        <p>자료실</p>
        <span>
          다양한 자료를
          <br />
          다운로드 받으실 수 있습니다.
        </span>
      </div>
    </div>
  );
}

export default App;
